// Chrome 38 Symbol has incorrect toString conversion
module.exports = !require('../internals/fails')(function () {
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/@firebase/polyfill/node_modules/core-js/internals/native-symbol.js
// module id = 543
// module chunks = 16